export default __webpack_public_path__ + "static/media/team_azrai.d9d6a274.png";